"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setInputStyle = exports.extractRestFromProps = exports.convertPageSizes = exports.retrievePageNumbers = exports.chunkItems = void 0;

var _value = require("../../skybase-core/utils/value");

var _constants = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var chunkItems = function chunkItems(_ref) {
  var pageSize = _ref.pageSize,
      totalCount = _ref.totalCount;

  if (!totalCount || !pageSize) {
    return [];
  }

  var chunks = [];
  var chunksCount = Math.floor(totalCount / pageSize);
  var lastChunkSize = totalCount % pageSize;

  for (var i = 0; i < chunksCount; i += 1) {
    chunks.push(createChunk({
      pageSize: pageSize,
      index: i
    }));
  }

  if (lastChunkSize) {
    chunks.push(createChunk({
      pageSize: pageSize,
      index: chunksCount,
      size: lastChunkSize
    }));
  }

  return chunks;
};

exports.chunkItems = chunkItems;

var createChunk = function createChunk(_ref2) {
  var pageSize = _ref2.pageSize,
      index = _ref2.index,
      size = _ref2.size,
      spacer = _ref2.spacer;
  return {
    number: index + 1,
    index: index,
    firstIndex: index * pageSize,
    lastIndex: size ? index * pageSize + size : (index + 1) * pageSize - 1,
    spacer: spacer
  };
};

var retrievePageNumbers = function retrievePageNumbers(_ref3) {
  var pageNumber = _ref3.pageNumber,
      chunks = _ref3.chunks,
      maxPreviousPages = _ref3.maxPreviousPages,
      maxNextPages = _ref3.maxNextPages;
  // worst case (needs the most buttons) => 1...9,  curr=5 => 1 ... 3 4 5 6 7 ... 9 = 4 extra buttons
  // therefore all other cases have to have at least worst-case-count
  var displayedPagesCount = maxNextPages + maxPreviousPages + 4;

  if (displayedPagesCount >= chunks.length) {
    return chunks;
  }

  var result = [];
  var firstPageIndex = pageNumber - maxPreviousPages - 2 > 0 && 0;
  var lastPageIndex = pageNumber + maxNextPages + 2 <= chunks.length && chunks.length - 1;

  if (firstPageIndex !== false) {
    // left spacer is visible!
    result.push(chunks[firstPageIndex]);
    result.push(createChunk({
      spacer: true,
      index: 1
    }));
  } // case when both spacers are visible


  var startingLoopIndex = firstPageIndex !== false ? pageNumber - maxPreviousPages - 1 : 0;
  var endingLoopIndex = lastPageIndex !== false ? pageNumber + maxNextPages : chunks.length; // if any (or both) of the spacers are invisible, the space reserved for spacers needs to filled with numbers/pages

  if (firstPageIndex === false && lastPageIndex !== false) {
    // left spacer is invisible and right space is visible
    endingLoopIndex = maxPreviousPages + maxNextPages + 3;
  } else if (firstPageIndex !== false && lastPageIndex === false) {
    // left spacer is visible and right space is invisible
    startingLoopIndex = chunks.length - maxPreviousPages - maxNextPages - 3;
  } // filling result with numbers/pages around the current page


  for (var i = startingLoopIndex; i < endingLoopIndex; i += 1) {
    result.push(chunks[i]);
  }

  if (lastPageIndex !== false) {
    // right spacer is visible!
    result.push(createChunk({
      spacer: true,
      index: lastPageIndex - 1
    }));
    result.push(chunks[lastPageIndex]);
  }

  return result;
};

exports.retrievePageNumbers = retrievePageNumbers;

var convertPageSizes = function convertPageSizes(pageSizes) {
  return pageSizes.reduce(function (result, size) {
    if (typeof size === 'number') {
      result.push({
        value: size.toString(),
        name: size.toString()
      });
    } else if (_typeof(size) === 'object') {
      var value = size.value,
          label = size.label,
          name = size.name;

      if (!(0, _value.isNullOrUndefined)(value)) {
        result.push({
          value: value.toString(),
          label: label || name || value
        });
      }
    }

    return result;
  }, []);
};

exports.convertPageSizes = convertPageSizes;

var extractRestFromProps = function extractRestFromProps(props) {
  var pageSize = props.pageSize,
      pageNumber = props.pageNumber,
      totalCount = props.totalCount,
      pageSizeDropdownProps = props.pageSizeDropdownProps,
      className = props.className,
      style = props.style,
      pageSizes = props.pageSizes,
      goToPage = props.goToPage,
      maxPreviousPages = props.maxPreviousPages,
      maxNextPages = props.maxNextPages,
      onChange = props.onChange,
      previousLabel = props.previousLabel,
      nextLabel = props.nextLabel,
      pageSizeLabel = props.pageSizeLabel,
      goToPageLabel = props.goToPageLabel,
      buttonClassName = props.buttonClassName,
      disabled = props.disabled,
      intl = props.intl,
      id = props.id,
      goToPageInputProps = props.goToPageInputProps,
      rest = _objectWithoutProperties(props, ["pageSize", "pageNumber", "totalCount", "pageSizeDropdownProps", "className", "style", "pageSizes", "goToPage", "maxPreviousPages", "maxNextPages", "onChange", "previousLabel", "nextLabel", "pageSizeLabel", "goToPageLabel", "buttonClassName", "disabled", "intl", "id", "goToPageInputProps"]);

  return rest;
};

exports.extractRestFromProps = extractRestFromProps;

var setInputStyle = function setInputStyle(style) {
  if (style) {
    var _style$width;

    return _objectSpread(_objectSpread({}, style), {}, {
      width: (_style$width = style.width) !== null && _style$width !== void 0 ? _style$width : _constants.DEFAULT_GO_TO_INPUT_WIDTH
    });
  }

  return {
    width: _constants.DEFAULT_GO_TO_INPUT_WIDTH
  };
};

exports.setInputStyle = setInputStyle;
//# sourceMappingURL=utils.js.map